import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2 text-foreground hover:text-primary transition-colors">
            <Icon name="ArrowLeft" size={20} />
            <Icon name="Send" size={24} className="text-primary" />
            <span className="font-bold text-lg">POSTRequest</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-foreground mb-2">Terms of Service</h1>
        <p className="text-muted-foreground mb-8">Last updated: March 27, 2026</p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              By using POSTRequest, you agree to these Terms of Service. If you do not agree, please do not use the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. Description of Service</h2>
            <p className="text-muted-foreground leading-relaxed">
              POSTRequest is an AI-powered content creation tool that helps developers and tech professionals transform their ideas into platform-optimized social media posts for LinkedIn and X (Twitter). The service includes content generation, refinement, and direct publishing capabilities.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. User Accounts</h2>
            <p className="text-muted-foreground leading-relaxed">
              You are responsible for maintaining the security of your account. You must provide accurate information when creating an account. You are responsible for all activity that occurs under your account, including content published through connected social media accounts.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Content Ownership</h2>
            <p className="text-muted-foreground leading-relaxed">
              You retain full ownership of the ideas and content you provide to POSTRequest. AI-generated content based on your input is yours to use as you see fit. We do not claim ownership of any content generated through the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Acceptable Use</h2>
            <p className="text-muted-foreground leading-relaxed">
              You agree not to use POSTRequest to generate or publish content that is illegal, harmful, defamatory, or violates the terms of service of connected platforms (LinkedIn, X). You must not attempt to circumvent usage limits, reverse-engineer the service, or use automated tools to abuse the platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Subscription & Billing</h2>
            <p className="text-muted-foreground leading-relaxed">
              POSTRequest offers Basic and Pro subscription tiers. Basic plan users have limited monthly usage. Paid subscriptions are billed through Razorpay. You can cancel your subscription at any time. Refunds are handled on a case-by-case basis — contact support for refund requests.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Usage Limits</h2>
            <p className="text-muted-foreground leading-relaxed">
              Free and paid tiers have usage limits on AI content generation, publishing, and other features. Limits reset monthly. Attempting to circumvent these limits may result in account suspension.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">8. Third-Party Services</h2>
            <p className="text-muted-foreground leading-relaxed">
              POSTRequest integrates with third-party services including Google (authentication), LinkedIn, X, OpenAI (content generation), and Razorpay (payments). Your use of these services through POSTRequest is also subject to their respective terms of service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">9. Limitation of Liability</h2>
            <p className="text-muted-foreground leading-relaxed">
              POSTRequest is provided "as is" without warranties of any kind. We are not responsible for content published through connected social media accounts, including any consequences arising from such publications. We are not liable for any indirect, incidental, or consequential damages.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">10. Changes to Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the updated terms. We will notify users of significant changes via email or in-app notification.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">11. Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              For questions about these terms, contact us at support@postrequest.social.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Terms;
